// Story 8.15 (ADO-2024), D-1 and D-6: the pure Auto-send rules the control shares. No React.
//
// The lead time is the server's (`autoSendLeadMinutes` on the cart read, its
// `AUTO_SEND_LEAD_MINUTES`), never a constant here, so the copy says what the send does.

import type { CutOffStatus } from '../api/basket.client';
import { countdownDeadline } from '../shared/cutOffDisplay';

/** "1 min before cut-off" (Figma `5008:41019`), for the lead time the server sends. */
export function autoSendLeadCopy(leadMinutes: number): string {
  return `${leadMinutes} min before cut-off`;
}

/** Whether the cart has a cut-off to send before (D-6): an open one, or the next one once today's
 *  has passed. A depot with no cut-off (NONE: depots 21, 25 and 85, Foodservice), a status still
 *  loading or failed, or a passed cut-off with none after it offer no Auto-send. */
export function autoSendOffered(status: CutOffStatus | null): boolean {
  return countdownDeadline(status) !== null;
}
